import {atom} from 'jotai'
import {z} from 'zod'

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number(),
    childFilters: z.array(z.object({})),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
})

export type ListFilter = z.infer<typeof listFilterSchema>

export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  // orderList: [{type: 2, key: 'dt'}],
  orderList: [{type: 2, key: 'crtdOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})
